module.exports = {
      id: "comm-sports-usage",
      viewBox: "0 0 411.122 51.012",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-sports",
      toString: function () {
        return this.url;
      }
    }